import { render, staticRenderFns } from "./mwe-emoji-picker.vue?vue&type=template&id=8e01bcb0&scoped=true&"
import script from "./mwe-emoji-picker.vue?vue&type=script&lang=js&"
export * from "./mwe-emoji-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e01bcb0",
  null
  
)

export default component.exports